import CustomTable from "@/components/customTable/CustomTable";
import { Box, IconButton, Typography } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { useMemo, useState } from "react";
import { removeExperiment } from "../../../../api/area";
import TrashIcon from "../../../../assets/SVG/trashIcon";

export default function TableLibray({ rowData, setRowData, moduleId }) {
  const colDefs = useMemo(
    () => [
      {
        headerName: "ردیف",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 100,
      },
      {
        field: "experiment",
        headerName: "نام خدمت",
        width: 300,
      },
      {
        field: "description",
        headerName: "علت درخواست",
        width: 300,
      },
      {
        headerName: "عملیات",
        width: 100,
        cellRenderer: (x, options = {}) => {
          const isMobile = options.mobile ?? false;
          return (
            <Box
              display="flex"
              gap="10px"
              alignItems="center"
              key={`op_${x.id}`}
              justifyContent={isMobile ? "end" : "unset"}
            >
              <IconButton
                onClick={() => {
                  removeExperiment(
                    window.location.search.split("?", 3)[1].split("&", 3)[0],
                    moduleId,
                    window.location.search.split("?", 3)[1].split("&", 4)[3],
                    x.data.id,
                  )
                    .then(() => {
                      setRowData((z) => {
                        let array = [...z];
                        array = array.filter((item) => item.id !== x.data.id);
                        return array;
                      });
                    })
                    .catch(() => {});
                }}
              >
                <TrashIcon />
              </IconButton>
            </Box>
          );
        },
      },
    ],
    [],
  );

  return (
    <>
      <Box bgcolor={"white"} p="15px 10px " mb="-15px" mt="20px">
        <Typography color={"var(--emr-darkblue)"} fontWeight="bold">
          {"جدول نسخه های ازمایشگاه"}
        </Typography>
      </Box>
      <CustomTable rowData={rowData} columns={colDefs} needPagination={false} />
    </>
  );
}
